import { Mail, MapPin } from 'lucide-react';

import ContentPage from '../components/ui/ContentPage';

const CHANNELS: { icon: typeof Mail; label: string; value: string; href?: string }[] = [
  {
    icon: Mail,
    label: 'Correo electrónico',
    value: 'info@leyro.es',
    href: 'mailto:info@leyro.es',
  },
  {
    icon: MapPin,
    label: 'Oficina central',
    value: 'Madrid — Calle Velázquez 80, 4º',
  },
  {
    icon: MapPin,
    label: 'Delegación',
    value: 'Pontevedra (Galicia)',
  },
];

export default function ContactPage(): JSX.Element {
  return (
    <ContentPage
      title="Contacto"
      intro="Estamos en Madrid e Galicia. Respondemos en xornada laboral (luns a venres, 9–18 h)."
    >
      <div className="grid sm:grid-cols-2 gap-4 not-prose">
        {CHANNELS.map((c) => {
          const Icon = c.icon;
          const body = (
            <>
              <div className="w-10 h-10 rounded-xl bg-rauxa/10 text-rauxa flex items-center justify-center shrink-0">
                <Icon size={18} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs uppercase tracking-wide text-muted font-medium">
                  {c.label}
                </div>
                <div className="text-sm font-semibold text-dark truncate">{c.value}</div>
              </div>
            </>
          );
          return c.href ? (
            <a
              key={c.label}
              href={c.href}
              className="flex items-center gap-3 p-4 rounded-2xl border border-border bg-white hover:shadow-card transition-shadow"
            >
              {body}
            </a>
          ) : (
            <div
              key={c.label}
              className="flex items-center gap-3 p-4 rounded-2xl border border-border bg-white"
            >
              {body}
            </div>
          );
        })}
      </div>

      <h2>Soporte para gandeiros</h2>
      <p>
        Se es gandeiro/a e tes dúbidas sobre o LeyroSpot, a anclaxe blockchain, a app móbil ou
        calquera outra cuestión, escribe a <a href="mailto:info@leyro.es">info@leyro.es</a>.
      </p>
    </ContentPage>
  );
}
